import React, { Component } from 'react'
import { withRouter } from 'react-router'

import Home from './components/Home'
import Project from './components/Projects/Project'
import ProjectsList from './components/Projects/ProjectsList'
import ProjectModal from './components/Projects/ProjectModal'
import Auth from './components/Auth'
import AppSettings from './components/AppSettings'
import AppSettingsCompany from './components/AppSettings/AppSettingsCompany'
import ProjectSettings from './components/ProjectSettings/index'
import ContactModal from './components/ContactModal/ContactModal'
import Messages from './components/Messages'
import Hubspot from './components/ProjectSettings/Integrations/Hubspot'
import logo from './logo.png'

import 'antd/dist/antd.css'
import { Layout } from 'antd'
const { Header, Content, Sider } = Layout

class App extends Component {
  state = {
    collapsed: false
  }

  toggleCollapsed = () => {
    this.setState(state => ({
      collapsed: !state.collapsed
    }))
  }

  render () {
    const { view, match: { params } } = this.props

    let appView = null
    switch (view) {
      case 'home':
        appView = <Home />
        break

      case 'project':
        appView = <Project key={params.projectId} />
        break

      case 'project-settings':
        appView = <ProjectSettings />
        break

      case 'settings':
        appView = <AppSettings />
        break

      case 'settings-company':
        appView = <AppSettingsCompany />
        break

      case 'hubspot':
        appView = <Hubspot />
        break

      default:
        break
    }

    return (
      <Layout style={{ height: '100vh' }}>

        <Messages />

        <Header
          style={{
            display: 'flex',
            height: '50px',
            lineHeight: '50px',
            padding: '0 16px',
            background: '#fff',
            borderBottom: '1px solid #ccc'
          }}
        >
          <a href='/' style={{ display: 'flex', alignItems: 'center', color: 'black' }}>
            <img src={logo} alt='CallBuddy logo' style={{ height: 40 }} />
            <span style={{ fontSize: 18, fontWeight: 'bold', marginLeft: 10 }}>CallBuddy</span>
          </a>
          <Auth />
        </Header>

        <Layout /* key={Date.now()} */>

          <Sider
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.toggleCollapsed}
            style={{ background: '#fff' }}
          >
            <div className='logo' />
            <ProjectsList />
          </Sider>

          <Content style={{ margin: '0 16px' }}>
            <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
              {appView}
            </div>
          </Content>

        </Layout>

        {process.env.NODE_ENV !== 'production' &&
          <div className='testing' style={{ position: 'absolute', right: 0, bottom: 0 }}>
            {process.env.REACT_APP_FIREBASE_PROJECT}
          </div>}

        <ContactModal />
        <ProjectModal />

      </Layout>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js